<template>
    <v-tooltip
        v-if="perms_allow"
        v-bind="$attrs"
        v-on="$listeners"
        :disabled="$attrs['disabled'] || $bp.smAndDown || modal_loader || $bp.width < 1400"
        :bottom="bottom"
    >
        <template v-for="(_, slot) of $slots" :slot=[slot]>
            <slot :name="slot"/>
        </template>
    </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';
	export default {
        props: {
            perm: {
                type: String,
                default: null
            },
        },
        computed: {
            ...mapGetters([
                'modal_loader'
            ]),
            bottom(){
                return typeof(this.$attrs.top)=='undefined' && typeof(this.$attrs.left)=='undefined' && typeof(this.$attrs.right)=='undefined';
            },
            perms_allow(){
                return !this.perm || this.hasPerm(this.perm);
            }
        }
    }
</script>